import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import {
  acceptAnalyticsCookies,
  declineAnalyticsCookies,
  getCookieConsentDecision,
} from "utils/cookieConsent";
import "styles/cookie-consent.css";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!getCookieConsentDecision());
  }, []);

  if (!visible) return null;

  const closeWithAcceptance = () => {
    acceptAnalyticsCookies();
    setVisible(false);
  };

  const closeWithDecline = () => {
    declineAnalyticsCookies();
    setVisible(false);
  };

  return createPortal(
    <section
      className="cookie-consent"
      aria-labelledby="cookie-consent-title"
      role="dialog"
      aria-modal="false"
    >
      <div className="cookie-consent__content">
        <p className="cookie-consent__eyebrow">Datenschutz</p>
        <h2 id="cookie-consent-title">Cookies und Analyse</h2>
        <p>
          Wir verwenden notwendige Speichertechniken für Buchung, Login und
          Sicherheit. Google Analytics laden wir nur, wenn du zustimmst. Die
          Website bleibt auch bei Ablehnung vollständig nutzbar.
        </p>
        <Link className="cookie-consent__link" to="/datenschutz#cookies">
          Mehr erfahren
        </Link>
      </div>

      <div className="cookie-consent__actions" aria-label="Cookie-Auswahl">
        <button
          type="button"
          className="cookie-consent__button"
          onClick={closeWithDecline}
        >
          Ablehnen
        </button>
        <button
          type="button"
          className="cookie-consent__button cookie-consent__button--primary"
          onClick={closeWithAcceptance}
        >
          Zustimmen
        </button>
      </div>
    </section>,
    document.body
  );
};

export default CookieConsentBanner;
